import './CSS/Estilo.css';
import {estiloGreen,estiloDark} from "./CSS/EstilosPagina";
import ToolBar from "./Componentes/SubComponentes/ToolBar";
import MenuDesplegable from "./Componentes/MenuDesplegable";
import {useState, useEffect, useCallback} from "react";
import Grid from '@mui/material/Grid';
import WebTheme from "./Componentes/SubComponentes/WebTheme"
import {CajaTexto, RotuloWebMediano, CajaTextoLectura} from "./Componentes/SubComponentes/CajasTexto";
import Footer from './Componentes/SubComponentes/Footer'
import { List, ListItem, ListItemText, Box, Typography} from '@mui/material';
import Link from "@mui/material/Link";

export default function OraxCookiesPolicy({modo})
{
    const pages = ((modo === 'oraxulux')?
        [ 'Ficheros', 'Contacto', 'Área privada']:
        [ 'Inicio','Sobre nosotros', 'Noticias y Actividades','Contacto','Área privada']);
    const opciones = ['Dark','Green']
    const [estiloPagina,setEstiloPagina]=useState((localStorage.getItem('estilo') === 'Dark')?estiloDark
        :estiloGreen);

    useEffect(()=>{
        sessionStorage.clear();
        localStorage.removeItem('Gestion');
    },[]);

    const opcionesOnClick = useCallback((ev) => {

        let pulsado = ev.target.id;
        let estilo = (pulsado === 'Dark')?estiloDark:estiloGreen;
        setEstiloPagina(() => estilo);
        localStorage.setItem('estilo',pulsado);
    },[]);

    const texto1 = `
        <p>
            Las cookies son pequeños archivos o dispositivos que se descargan y almacenan en tu terminal (es decir, el dispositivo desde el que accedes
            a la web: Ordenador, teléfono móvil, tablet o cualquier otro dispositivo conectado) y permiten que la página, aplicación o sitio web recuerde
            información sobre tu visita.<br/><br/>

            Con carácter general, y tal y como recoge la Guía de Cookies publicada por la Agencia Española de Protección de Datos (AEPD), las cookies
            pueden ser de varios tipos:<br/><br/>

            Según quien sea la entidad que gestione el equipo o dominio desde donde se envían las cookies y trate los datos que se obtengan,
            podemos distinguir:
            <ul>
               <li>
                   <b>Cookies propias:</b> Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el editor de
                   la web, en este caso Frater Barcelona, desde el que se presta el servicio solicitado por el usuario.
               </li>
                <li>
                    <b>Cookies de terceros:</b> Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor
                    de la web, sino por otra entidad que trata los datos obtenidos a través de las cookies.
                </li>
            </ul>


            Según la finalidad para la que se traten los datos obtenidos a través de las cookies, podemos distinguir entre:
            <ul>
                <li>
                    <b>Cookies técnicas:</b> Son aquéllas que permiten al usuario la navegación a través del sitio web y la utilización de las diferentes opciones o servicios que
                    en ella existan como, por ejemplo, identificar la sesión, acceder a información de acceso restringido, etc.
                </li>
                <li>
                    <b>Cookies de personalización:</b> Son aquéllas que permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en
                    función de una serie de criterios en el terminal del usuario como, por ejemplo, el idioma, el tipo de navegador a través del cual accede al servicio, o la
                    configuración regional desde donde accede al servicio, entre otras.
                </li>
                <li>
                    <b>Cookies de análisis:</b> Son aquéllas que permiten al responsable de las mismas, el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los
                    que están vinculadas. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad en la plataforma y para la elaboración de perfiles de
                    navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios
                    del servicio.
                </li>
                <li>
                    <b>Cookies publicitarias:</b> Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.
                    Cookies de publicidad comportamental: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.
                    Según el plazo de tiempo que permanecen activadas en el equipo terminal (temporalidad) podemos distinguir:
                    que puede ir de unos minutos a varios años.
                </li>
                <li>
                    <b>Cookies de sesión:</b> Cookies diseñadas para recabar y almacenar datos mientras el usuario accede a la plataforma. Las cookies de sesión permiten que
                    un sitio web reconozca al usuario.
                </li>
                <li>
                    <b>Cookies persistentes:</b> Cookies en el que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un período definido
                    por el responsable de la cookie, y que puede ir de unos minutos a varios años.
                </li>
            </ul>
        </p>
    `

    const texto2 = `
        <p>
            Este sitio web no usa cookies, en su lugar, utilizamos la funcionalidad de html5 <Link href='https://developer.mozilla.org/es/docs/Web/API/Window/localStorage'> Local Storage
            </Link>{' '} mediante la cual, almacenamos en el navegador del usuario el tema de color que prefiere ( verde o de alto contraste ).Esta información se guarda de manera
            persistente, es decir, persiste aunque se salga de la web o se cierre el navegador.<br/><br/>
            Cuando un usuario registrado accede al área privada mediante su nombre y contraseña, el servidor envia a su navegador un token de sesión que se almacena en este
            mediante la funcionalidad de html5 <Link href='https://developer.mozilla.org/es/docs/Web/API/Window/sessionStorage'>Session Storage</Link>{''}. Este token no es
            persistente, se borra cuando el usuario sale del área privada o cierra el navegador.<br/><br/>
            Esto es lo único que almacenamos en tu equipo, tampoco usamos publicidad ni cesión de datos de ningún tipo a terceros.
        <p/>
    `



    return(
        <Box className='Cont' style={{background:estiloPagina.background , height:'250vh'}}>
            <Box className='ToolBar'>
                <ToolBar
                    gadgets={[
                        <MenuDesplegable
                            key='1'
                            opciones={opciones}
                            opcionesOnClick={opcionesOnClick}>
                        </MenuDesplegable>]}
                    paginas={pages}
                    estilo ={estiloPagina}
                    modo = {modo}>
                </ToolBar>
            </Box>
            <Box className='Cabecera'>
                <h1 style={{margin:'auto',color:(estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen,fontWeight:200}}>
                    Política de cookies
                </h1>
            </Box>
            <Box className = 'AreaNegocio' style={{background:estiloPagina.background}} >
                <Box sx={{border:(estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen,
                          ml:'1%',
                          mr:'1%'}}>
                    <RotuloWebMediano texto={'¿Qué son las cookies?'} marginBottom={'1%'} estiloPagina={estiloPagina}></RotuloWebMediano>
                    <CajaTextoLectura texto={texto1} marginLeft={'1%'} estiloPagina={estiloPagina}></CajaTextoLectura>
                </Box>
                <Box sx={{border:(estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen,
                    ml:'1%',
                    mr:'1%',
                    mt:'2%'}}>
                    <RotuloWebMediano texto={'¿Qué cookies utiliza este sitio web?'} marginBottom={'1%'}></RotuloWebMediano>
                    <CajaTextoLectura texto={texto2} marginLeft={'1%'} estiloPagina={estiloPagina}></CajaTextoLectura>
                </Box>
            </Box> {/*Areanegocio*/}
            <Footer estilo={estiloPagina} modo={modo}></Footer>
        </Box>
    )
}
